/**
 * mergeProviders
 *
 * this routine handles the heavy lifting for
 * merging specified Providers into one Provider
 *
 **/
import React from 'react';
export const mergeProviders = function () {
  for (var _len = arguments.length, components = new Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }
  return components.reduce((AccumulatedComponents, CurrentComponent) => {
    return _ref => {
      let {
        children
      } = _ref;
      return /*#__PURE__*/React.createElement(AccumulatedComponents, null, /*#__PURE__*/React.createElement(CurrentComponent, null, children));
    };
  }, _ref2 => {
    let {
      children
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  });
};
//# sourceMappingURL=mergeContextProviders.js.map